import initialState from '../store/initialState'
import preferencesTypes from '../constants/preferencesTypes'

export default function preferencesReducer(state = initialState.preferences, action) {
  switch (action.type) {

    // RESET

    case preferencesTypes.reset: {
      return {
        ...initialState.preferences,
        items: state.items,
        skill: state.skill,
        fetching: false,
        fetched: false,
        mustRedirect: false,
        errors: []
      }
    }

    // INDEX
    case preferencesTypes.index.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        mustRedirect: false,
        errors: []
      }
    }

    case preferencesTypes.index.success: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        mustRedirect: false,
        preferences: action.payload.preferences,
        levels: action.payload.levels,
        errors: []
      }
    }

    case preferencesTypes.index.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    // UPDATE
    case preferencesTypes.update.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        mustRedirect: false,
        errors: []
      }
    }

    case preferencesTypes.update.success: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        mustRedirect: true,
        preferences: action.payload.preferences,
        levels: action.payload.levels,
        errors: []
      }
    }

    case preferencesTypes.update.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        mustRedirect: false,
        errors: action.payload
      }
    }

    default: {
      return {...state};
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/preferencesReducer.js